export default {
  userHasRole(roleList) {
    const currentRole = JSON.parse(localStorage.getItem("roles"))[0].rol;
    return roleList.some((role) => role === currentRole);
  },
};
